import { Injectable } from "@angular/core";
import { SidemenuOptions, ToolbarOptions } from "@cotecna/shell";

import {
  ABOUT_ACTION_ICON,
  ABOUT_ACTION_LABEL,
  ABOUT_ACTION_NAME,
  BI_REPORTS_ACTION_ICON,
  BI_REPORTS_ACTION_LABEL,
  BI_REPORTS_ACTION_NAME,
  COTECNA_EYE,
  DASHBOARDS_ACTION_ICON,
  DASHBOARDS_ACTION_LABEL,
  DASHBOARDS_ACTION_NAME,
  INSPECTIONS_ACTION_ICON,
  INSPECTIONS_ACTION_LABEL,
  INSPECTIONS_ACTION_NAME,
  LOGOUT_ACTION_ICON,
  LOGOUT_ACTION_LABEL,
  LOGOUT_ACTION_NAME,
  MULTIOFFICE_ACTION_ICON,
  MULTIOFFICE_ACTION_LABEL,
  MULTIOFFICE_ACTION_NAME,
  REPORT_ISSUE_ACTION_ICON,
  REPORT_ISSUE_ACTION_LABEL,
  REPORT_ISSUE_ACTION_NAME,
  RESOURCES_ACTION_ICON,
  RESOURCES_ACTION_LABEL,
  RESOURCES_ACTION_NAME,
  SEARCH_ACTION_ICON,
  SEARCH_ACTION_LABEL,
  SEARCH_ACTION_NAME,
  SETTINGS_ACTION_ICON,
  SETTINGS_ACTION_LABEL,
  SETTINGS_ACTION_NAME,
  TIMESHEET_ACTIVITIES_ACTION_ICON,
  TIMESHEET_ACTIVITIES_ACTION_LABEL,
  TIMESHEET_ACTIVITIES_ACTION_NAME,
  COTECNA_USER_KEY,
} from "../constants/constants";
import { UserRolePermissionsService } from "src/app/shared/services/user-role-permissions/user-role-permissions.service";

@Injectable({
  providedIn: "root",
})
export class AppShellService {
  private readonly defaultTitle = this.getSessionTitle();

  public toolbarOptions: ToolbarOptions = {
    showMenuButton: true,
    showBackButton: false,
    title: this.defaultTitle,
    mainActions: [
      {
        name: SEARCH_ACTION_NAME,
        label: SEARCH_ACTION_LABEL,
        icon: SEARCH_ACTION_ICON,
      },
    ],
    moreActions: [],
    showCloseButton: false,
  };

  public sideMenuOptions: SidemenuOptions = {
    emptyShell: false,
    sidemenuActions: [
      {
        id: MULTIOFFICE_ACTION_NAME,
        name: MULTIOFFICE_ACTION_LABEL,
        icon: {
          name: MULTIOFFICE_ACTION_ICON,
        },
      },
      {
        id: INSPECTIONS_ACTION_NAME,
        name: INSPECTIONS_ACTION_LABEL,
        icon: {
          name: INSPECTIONS_ACTION_ICON,
        },
      },
      {
        id: TIMESHEET_ACTIVITIES_ACTION_NAME,
        name: TIMESHEET_ACTIVITIES_ACTION_LABEL,
        icon: {
          name: TIMESHEET_ACTIVITIES_ACTION_ICON,
        },
      },
      {
        id: RESOURCES_ACTION_NAME,
        name: RESOURCES_ACTION_LABEL,
        icon: {
          name: RESOURCES_ACTION_ICON,
        },
      },
      {
        id: BI_REPORTS_ACTION_NAME,
        name: BI_REPORTS_ACTION_LABEL,
        icon: {
          name: BI_REPORTS_ACTION_ICON,
        },
      },
      {
        id: DASHBOARDS_ACTION_NAME,
        name: DASHBOARDS_ACTION_LABEL,
        icon: {
          name: DASHBOARDS_ACTION_ICON,
        },
      },
      {
        id: ABOUT_ACTION_NAME,
        name: ABOUT_ACTION_LABEL,
        icon: {
          name: ABOUT_ACTION_ICON,
        },
      },
      {
        id: SETTINGS_ACTION_NAME,
        name: SETTINGS_ACTION_LABEL,
        icon: {
          name: SETTINGS_ACTION_ICON,
        },
      },
      {
        id: LOGOUT_ACTION_NAME,
        name: LOGOUT_ACTION_LABEL,
        icon: {
          name: LOGOUT_ACTION_ICON,
        },
      },
    ],
    toolbarOptions: this.toolbarOptions,
  };

  constructor(private readonly userRolePermissionsService: UserRolePermissionsService) {}

  private getSessionTitle(): string {
    if (this.userRolePermissionsService.isInspector()){
      return COTECNA_EYE;
    } else {
      const storedUser = this.readStoredUser();
      
      if (storedUser?.secondaryAccountIds?.length === 0) {
        return COTECNA_EYE;
      }

      return storedUser?.accountName
        ? `${COTECNA_EYE}: ${storedUser.accountName}`
        : COTECNA_EYE;
    }    
  }

  private readStoredUser(): any {
    try {
      const rawUser = globalThis.sessionStorage?.getItem(COTECNA_USER_KEY);

      return rawUser ? JSON.parse(rawUser) : null;
    } catch {
      return null;
    }
  }

  public refreshToolbarOptionsTitle(): void {
    this.toolbarOptions = {
      ...this.toolbarOptions,
      title: this.getSessionTitle(),
    };
    this.sideMenuOptions = {
      ...this.sideMenuOptions,
      toolbarOptions: this.toolbarOptions,
    };
  }

  public tryAddReportIssueAction(): void {
    if (
      !this.sideMenuOptions.toolbarOptions.mainActions.some(
        (x) => x.name === REPORT_ISSUE_ACTION_NAME,
      )
    )
      this.sideMenuOptions.toolbarOptions.mainActions.push({
        name: REPORT_ISSUE_ACTION_NAME,
        label: REPORT_ISSUE_ACTION_LABEL,
        icon: REPORT_ISSUE_ACTION_ICON,
      });
  }
}
